"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var slideout_1 = __importDefault(require("slideout"));
var config_1 = __importDefault(require("../config"));
var overlay_1 = __importDefault(require("../modules/overlay"));
var utilities_1 = require("./utilities");
var filters_1 = __importDefault(require("../modules/filters"));
var miniBasket_1 = __importDefault(require("../modules/miniBasket"));
var menuSlideout_1 = __importDefault(require("../modules/menuSlideout"));
var Slideout = /** @class */ (function () {
    function Slideout() {
        var _this = this;
        this.restartModules = function () {
            filters_1.default.reinit();
            menuSlideout_1.default.reinit();
            miniBasket_1.default.reinit();
        };
        this.load = function (slideout, options) {
            slideout = new slideout_1.default(__assign(__assign({}, _this.defaultOptions), options));
            slideout.on('beforeopen', _this.handleBeforeOpen.bind(_this, _this.defaultOptions.menu, slideout));
            slideout.on('close', _this.handleClose.bind(_this, _this.defaultOptions.menu, slideout));
            slideout.on('open', _this.handleOpen.bind(_this, _this.defaultOptions.menu, slideout));
            slideout.on('translateend', _this.handleTranslateEnd.bind(_this, _this.defaultOptions.menu, slideout));
            slideout.openBtns = options && options.openBtns ? options.openBtns : null;
            slideout.closeBtns = options && options.closeBtns ? options.closeBtns : null;
            return slideout;
        };
        this.handleResize = (0, utilities_1.debounce)(function (slideout, options) {
            _this.reinit(slideout, options);
        }, 250);
        this.handleOpen = function (menu, slideout) {
            slideout.enableTouch();
        };
        this.handleBeforeOpen = function (menu) {
            overlay_1.default.on();
            menu.style.width = (0, utilities_1.isDesktop)() ? "".concat(_this.config.desktopWidth, "px") : "".concat(window.innerWidth - _this.config.mobileGutter, "px");
            menu.classList.add('slideout-menu--active');
        };
        this.handleClose = function (menu, slideout) {
            overlay_1.default.off();
            slideout.disableTouch();
            menu.classList.remove('slideout-menu--active');
        };
        this.handleTranslateEnd = function () {
            overlay_1.default.off();
        };
        this.slideout = null;
        this.config = {
            desktopWidth: 400,
            mobileGutter: config_1.default.gutter * 6
        };
        this.defaultOptions = {
            menu: null,
            panel: document.querySelector('[data-slideout-panel]'),
            duration: config_1.default.duration,
            touch: false,
            padding: this.config.mobileGutter
        };
    }
    Slideout.prototype.init = function (menuNode, options) {
        this.defaultOptions.menu = menuNode;
        this.defaultOptions.padding = (0, utilities_1.isDesktop)() ? this.config.desktopWidth : window.innerWidth - this.config.mobileGutter;
        this.slideout = this.load(this.slideout, options);
        window.addEventListener('resize', this.handleResize.bind(this, this.slideout, options));
        overlay_1.default.config.overlay.addEventListener('click', this.handleOverlayClick.bind(this, this.slideout));
        return this.slideout;
    };
    Slideout.prototype.reinit = function (slideout, options) {
        this.defaultOptions.padding = (0, utilities_1.isDesktop)() ? this.config.desktopWidth : window.innerWidth - this.config.mobileGutter;
        slideout = this.destroy(slideout);
        slideout = this.load(slideout, options);
        this.restartModules();
    };
    Slideout.prototype.handleOverlayClick = function (slideout) {
        slideout.close();
    };
    Slideout.prototype.destroy = function (slideout) {
        if (slideout) {
            slideout.close();
            slideout.destroy();
            slideout.menu.style.width = 'auto';
        }
        if (slideout && slideout.menu) {
            slideout.menu.classList.remove('slideout-menu');
            slideout.menu.classList.remove('slideout-menu-left');
            slideout.menu.classList.remove('slideout-menu-right');
        }
        return null;
    };
    return Slideout;
}());
exports.default = new Slideout();
